import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { TokenLink } from './token-link';
export { TokenLink };
import { tokenLinkSchema } from '@schemas/business-objects/token-link';
import { TenantFormGroup } from './tenant-form-group';
import { TokenFormGroup } from './token-form-group';

export class TokenLinkFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    downstreamTokenId: SchemaFormControl;
    downstreamToken: TokenFormGroup;
    upstreamTokenId: SchemaFormControl;
    upstreamToken: TokenFormGroup;
    tenantId: SchemaFormControl;
    tenant: TenantFormGroup;
  };

  declare value: Partial<TokenLink>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(tokenLinkSchema, TokenLink, data, options);
  }

  get object(): TokenLink {
    return new TokenLink(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'downstreamToken':
        return new TokenFormGroup();
      case 'upstreamToken':
        return new TokenFormGroup();
      case 'tenant':
        return new TenantFormGroup();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<TokenLink[]> {
    return TokenLink.find(filter);
  }

  static async findOne(filter?: any): Promise<TokenLink | null> {
    return TokenLink.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<TokenLink> {
    return TokenLink.findById(id, filter);
  }

  static async create(data: Partial<TokenLink>): Promise<TokenLink> {
    return TokenLink.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<TokenLink>,
  ): Promise<TokenLink> {
    return TokenLink.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return TokenLink.deleteById(id);
  }

  static async findByDownstream(options: any): Promise<any> {
    return TokenLink.findByDownstream(options);
  }

  static async findByUpstream(options: any): Promise<any> {
    return TokenLink.findByUpstream(options);
  }
}

export class TokenLinkFormArray extends PersistedFormArray {
  declare controls: TokenLinkFormGroup[];

  readonly entityName = 'TokenLink' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(tokenLinkSchema, TokenLink, options);
  }

  protected override createItemGroup() {
    return new TokenLinkFormGroup();
  }

  get array(): TokenLink[] {
    return this.controls.map((group: TokenLinkFormGroup) => group.object);
  }
}

export class TokenLinkPersistedArray extends PersistedArray<TokenLink> {
  readonly entityName = 'TokenLink' as const;

  constructor(options?: PersistedArrayOptions) {
    super(TokenLink, options);
  }
}
